module.exports = __webpack_public_path__ + "img/practice-in-progress.8849a522.svg";